import { createFileRoute, redirect } from '@tanstack/react-router';
import { TOTAL_STEPS } from 'components/pages/onboarding-my-plan/steps';
import { OnboardingMyPlanSkeleton } from 'pages/onboarding-my-plan/components/skeleton';
import { lazy, Suspense } from 'react';
import { stepParamSchema } from 'router/schemas';

const OnboardingMyPlan = lazy(() => import('pages/onboarding-my-plan'));

export const Route = createFileRoute('/_authenticated/_onboarding/onboarding/my-plan/$step')({
  beforeLoad: ({ params }) => {
    const result = stepParamSchema.safeParse(params);

    if (!result.success || result.data.step > TOTAL_STEPS) {
      // @ts-expect-error strictNullChecks breaks TanStack Router inference
      throw redirect({ to: '/onboarding/my-plan/$step', params: { step: '1' } });
    }
  },
  component: OnboardingMyPlanStepWrapper,
});

function OnboardingMyPlanStepWrapper() {
  const { step } = Route.useParams();
  const stepNumber = parseInt(step, 10);

  return (
    <Suspense fallback={<OnboardingMyPlanSkeleton />}>
      <OnboardingMyPlan step={stepNumber} />
    </Suspense>
  );
}
